/**
 * facebookLogin.js
 * Written by: Alex Kasemir
 */

import { authenticateFacebook } from '../authenticateFacebook';
import event from '../../../../utils/event';
import { fbEnsureInit } from '../../../../utils';

export const FACEBOOK_LOGIN_START = `FACEBOOK_LOGIN_START`;
export const FACEBOOK_LOGIN_SUCCESS = `FACEBOOK_LOGIN_SUCCESS`;
export const FACEBOOK_LOGIN_FAILURE = `FACEBOOK_LOGIN_FAILURE`;

export const facebookLoginStart = () => ({
  type: FACEBOOK_LOGIN_START,
});

export const facebookLoginSuccess = () => ({
  type: FACEBOOK_LOGIN_SUCCESS,
});

export const facebookLoginFailure = (error) => ({
  type: FACEBOOK_LOGIN_FAILURE,
  error,
});

/**
 * Description of the facebookLogin action
 */
export const facebookLogin = (location) => {
  return async (dispatch) => {
    event(`auth-init`, [`click`, `facebook-init`, location]);
    fbEnsureInit(() => {
      FB.getLoginStatus((status, authResponse) => {
        if (status === `connected`) {
          dispatch(facebookLoginSuccess());
          dispatch(authenticateFacebook(authResponse));
        } else {
          FB.login((response) => {
            if (response.status === `connected`) {
              dispatch(facebookLoginSuccess());
              dispatch(authenticateFacebook(response.authResponse.accessToken));
            } else {
              // they didnt connect to facebook or authorize your app.
              event(`auth-failure`, [`auth`, `facebook-failure`, `${response.status}`]);
            }
            return response.status;
          }, {
            scope: `public_profile, user_friends, email`,
          });
        }
      });
    });
  };
};
